// react
import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";

// kendo
import kendo from "@progress/kendo-ui";
import { Dialog, DialogActionsBar, Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Checkbox } from '@progress/kendo-react-inputs';
import { Button } from "@progress/kendo-react-buttons";

// css
import styles from './login_mobile.module.css';
import "./login_mobile.css";

// services
import sha512 from "js-sha512";
import { login, setToken, setDelToken, isLogin, delAdmToken } from "../../../service/authService";
import { getMessage } from "../../../com/messageUtil";
import { getUserInfo } from "../../../service/mobile/userInfoService";
import { getAccountInfo, setPersonalInformationConsent } from "../../../service/mngt/accoutMngtService";
import axios from 'axios';

function LoginMobile({ conn, setUpdateLoginStatus }) {

  document.body.style.backgroundColor = "#ECECEC";

  const history = useHistory();

  // DIALOG 설정
  const [completeDialogVisible, setCompleteDialogVisible] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("확인을 눌러주세요.");
  const closeCompleteDialog = () => {
    setCompleteDialogVisible(false);
  }
  const [picDialogVisible, setPicDialogVisible] = useState(false);
  const closePicDialog = () => {
    setDelToken();
    setPicDialogVisible(false);
  }

  const [questionDialogVisible, setQuestionDialogVisible] = useState(false);
  const saveQuestionDialog = () => {
    delAdmToken(conn, id)
    .then(() => {
      login(conn, id, password).then((result) => {
        setToken(result.token);
        setUpdateLoginStatus(true);
        history.push("/user/info");
      });
    })
    .catch((e) => {
      kendo.alert(getMessage(e.errCode));
    });
    setQuestionDialogVisible(false);
  }
  const closeQuestionDialog = () => {
    setQuestionDialogVisible(false);
  };

  let [id, setId] = useState("");
  let [password, setPassword] = useState("");

  const [userInfo, setUserInfo] = useState({
    userId: null,
    personalInformationConsentYn: null,
    personalInformationConsentIp: null,
    personalInformationConsentGathDtm: null,
    personalInformationConsentEndDtm: null,
  })

  const [check, setCheck] = useState({
    wholeCheck: false,
    checked1: false,
    checked2: false,
    checked3: false,
    buttonState: true,
  })

  const startApp = () => {

    setPersonalInformationConsent(conn, userInfo)
    .then(() => {
      setUpdateLoginStatus(true);
      setPicDialogVisible(false);
    });

  }


  const inputChage = event => {
    if (event.target.name === "id") {
      setId(event.target.value);
    } else {
      setPassword(event.target.value);
    }
  };

  const appKeyPress = e => {
    if (e.key === "Enter") {
      clickLogin();
    }
  };

  const clickLogin = () => {
    if (id === "") {
      setDialogMessage("아이디를 입력해주세요.");
      setCompleteDialogVisible(true);
      return;
    }
    if (password === "") {
      setDialogMessage("비밀번호를 입력해주세요.");
      setCompleteDialogVisible(true);
      return;
    }
    const encryptPw = sha512.sha512(password);

    login(conn, id, password)
    .then(result => {
      setToken(result.token);
      const data = {userId: id};
      getAccountInfo(conn, data)
      .then(response => {
        if(response.personalInformationConsentYn === "Y") {
          setUpdateLoginStatus(true);
        } else {
          axios.get('https://geolocation-db.com/json/')
          .then((res) => {
            setUserInfo(userInfo => {
              const item = { ...userInfo };
              item.userId = response.userId;
              item.personalInformationConsentIp = res.data.IPv4;
              return item;
            })
          })
          setPicDialogVisible(true);
        }
      })
      .catch(err => {
        console.log("getAccountInfo err = ", err);
      })
    })
    .catch(e => {
      // if (e.errCode === "F013") {
      //   setDialogMessage(getMessage(e.errCode) + "기존 접속중인 기기에서 로그아웃 하고 로그인 하시겠습니까? ");
      //   setQuestionDialogVisible(true);
      // } else {
        setDialogMessage(getMessage(e.errCode));
        setCompleteDialogVisible(true);
      // }
      // alert(getMessage(e.errCode));
    });

    setCheck(check => {
      const item = {...check};
      item.wholeCheck = false;
      item.checked1 = false;
      item.checked2 = false;
      item.checked3 = false;
      item.buttonState = true;
      return item;
    })   
  };

  const consent = (e) => {
    if(e.target.id === "checked") {
      check.wholeCheck = false;
      check.checked1 = false;
      check.checked2 = false;
      check.checked3 = false;
      setCheck(check => {
        const item = {...check};
        item.wholeCheck = false;
        item.checked1 = false;
        item.checked2 = false;
        item.checked3 = false;
        return item;
      })
    } else if(e.target.id === "unChecked") {
      check.wholeCheck = true;
      check.checked1 = true;
      check.checked2 = true;
      check.checked3 = true;
      setCheck(check => {
        const item = {...check};
        item.wholeCheck = true;
        item.checked1 = true;
        item.checked2 = true;
        item.checked3 = true;
        return item;
      })
    } else if(e.target.id === "checked1") {
      check.checked1 = false;
      setCheck(check => {
        const item = {...check};
        item.checked1 = false;
        return item;
      })
    } else if(e.target.id === "unChecked1") {
      check.checked1 = true;
      setCheck(check => {
        const item = {...check};
        item.checked1 = true;
        return item;
      })
    } else if(e.target.id === "checked2") {
      check.checked2 = false;
      setCheck(check => {
        const item = {...check};
        item.checked2 = false;
        return item;
      })
    } else if(e.target.id === "unChecked2") {
      check.checked2 = true;
      setCheck(check => {
        const item = {...check};
        item.checked2 = true;
        return item;
      })
    } else if(e.target.id === "checked3") {
      check.checked3 = false;
      setCheck(check => {
        const item = {...check};
        item.checked3 = false;
        return item;
      })
    } else if(e.target.id === "unChecked3") {
      check.checked3 = true;
      setCheck(check => {
        const item = {...check};
        item.checked3 = true;
        return item;
      })
    } else {
      setCheck(check => {
        const item = {...check};
        item.wholeCheck = false;
        item.checked1 = false;
        item.checked2 = false;
        item.checked3 = false;
        return item;
      })
    }

    if(check.checked1 && check.checked2 && check.checked3) {
      setCheck(check => {
        const item = {...check};
        item.wholeCheck = true;
        item.buttonState = false;
        return item;
      })
      document.getElementById("start").style.background = '#598ebd';
    } else {
      setCheck(check => {
        const item = {...check};
        item.wholeCheck = false;
        item.buttonState = true;
        return item;
      })
      document.getElementById("start").style.background = '#9abfdf';
    }
  }

  const successCallback = (position) => {
    console.log("position", position)
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    
  }

  const errorCallback = (err) => {
    console.log("getCurrentPostion err = ", err)
  }

  useEffect(() => {

  //   navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
  
  }, []);

  return (
    <>
      <div className={styles.loginContentInner_m}>
        <div className={styles.loginTop_m}>
          <img className={styles.loginImg_m} src="/images/mobile/login.png"></img>
          <span className={styles.loginTitle_m}>안심박스<br/>모니터링<br/>서비스</span>
        </div>
        <div className={styles.loginBottom_m}>
          <div className={styles.loginId_m}>
            <img className={styles.loginIcon_m} src="/images/mobile/id.png"></img>
            <input className={styles.loginInput_m} type="text" name="id" placeholder="아이디 입력" onChange={inputChage}/>
          </div>
          <div className={styles.loginPw_m}>
            <img className={styles.loginIcon_m} src="/images/mobile/pw.png"></img>
            <input className={styles.loginInput_m} type="password" name="password" placeholder="비밀번호 입력" onChange={inputChage} onKeyPress={appKeyPress} />
          </div>
          <div className={styles.loginBtn_m} onClick={clickLogin}>
              로그인
          </div>
          <img className={styles.bottomLogo_m} src="/images/mobile/company.png"/>
        </div>
        {completeDialogVisible && (
          <Dialog
            className="completeDialog"
            width={"90vw"}
            height={"40vw"}
            closeIcon={false}
          >
            <p>
              {dialogMessage}
              <br></br>
              <button onClick={closeCompleteDialog}>확인</button>
            </p>
          </Dialog>
        )}
        {picDialogVisible && (
          <Dialog
            className={styles.picDialog}
            width={"90%"}
            height={"90%"}
          >
            <div className={styles.picDialogHeader}>
              <div className={styles.picDialogHeaderCheck}>
                {
                  check.wholeCheck ?
                  <img className={styles.checkedBigImg} id="checked" src="/images/mobile/check/check_L1.png" onClick={consent}></img>
                  :
                  <img className={styles.checkedBigImg} id="unChecked" src="/images/mobile/check/check_L2.png" onClick={consent}></img>
                }
                <span className={styles.consentText}>약관 전체 동의</span>
              </div>
              <div className={styles.picDialogHeaderClose}>
                <span className={styles.closeBtn} onClick={closePicDialog}><img src="/images/closeBtn.png"></img></span>
              </div>
            </div>
            <div className={styles.picDialogContent}>
              <div className={styles.content1}>
                <b>개인정보 수집‧이용 동의</b>
              </div>
              <div className={styles.content2}>
                『개인정보보호법』 제 15조 법규에 의거하여<br/>
                <b>㈜제이케이코어</b>는 고객님의 개인정보 수집 및 이용에<br/>
                대해 개인정보 수집 및 이용 동의서를 받고 있습니다.<br/>
                <br/>
                개인정보 제공자가 동의한 내용 외의 다른 목적으로<br/>
                활용하지 않으며, 제공된 개인정보의 이용을 거부하고자<br/> 
                할 때에는 개인정보 관리책임자를 통해 열람, 정정<br/> 
                혹은 삭제를 요구할 수 있습니다.<br/>
                <br/>
              </div>
              <div className={styles.content3}>
                {
                  check.checked1 ?
                  <img className={styles.checkedSmallImg} id="checked1" src="/images/mobile/check/check_s1.png" onClick={consent}></img>
                  :
                  <img className={styles.checkedSmallImg} id="unChecked1" src="/images/mobile/check/check_s2.png" onClick={consent}></img>
                }
                [필수] 개인정보의 수집‧이용 목적<br/>
                - 서비스 제공에 관한 계약 이행 및 서비스 기능 구현<br/>
                - 회원관리 및 사용자 보호, 본인 확인, 개인 식별,<br/> 
                  부정이용방지 및 차단<br/>
                <br/>
                {
                  check.checked2 ?
                  <img className={styles.checkedSmallImg} id="checked2" src="/images/mobile/check/check_s1.png" onClick={consent}></img>
                  :
                  <img className={styles.checkedSmallImg} id="unChecked2" src="/images/mobile/check/check_s2.png" onClick={consent}></img>
                }
                [필수] 수집하는 개인정보의 항목<br/>
                - 로그인 시 표출되는 개인정보 항목 :<br/> 
                  이름, 사진, 전화번호<br/>
                - 서비스 이용 및 사용자 보호를 위한 자동 생성정보 :<br/> 
                  위치정보, IP주소, 기기 식별자, 기기종류<br/>
                <br/>
                {
                  check.checked3 ?
                  <img className={styles.checkedSmallImg} id="checked3" src="/images/mobile/check/check_s1.png" onClick={consent}></img>
                  :
                  <img className={styles.checkedSmallImg} id="unChecked3" src="/images/mobile/check/check_s2.png" onClick={consent}></img>
                }
                [필수] 개인정보의 보유‧이용 기간<br/>
                - 개인정보 수집‧이용 동의 시점으로부터 1년
              </div>
            </div>
            <div className={styles.picDialogFooter}>
              <button id="start" disabled={check.buttonState} onClick={startApp}>안심박스 시작하기</button>
            </div>
          </Dialog>
        )}
        {questionDialogVisible && (
        <Dialog
          className="completeDialog"
          width={"90vw"}
          height={"40vw"}
          closeIcon={false}
        >
          <p>
            {dialogMessage}
            <br></br>
            <button onClick={saveQuestionDialog}>확인</button>
            <button style={{ color: "black", background: "#dddddd", marginLeft: "2vw"}} onClick={closeQuestionDialog}>취소</button>
          </p>
        </Dialog>
      )}
        {/* <div className={styles.loginBottom_m}>
        </div> */}
      </div>
    </>
  );
}
export default LoginMobile;
